module.exports = __webpack_public_path__ + "static/business-areas-sm-856667db27c971e906574820c0b37bc4.jpg";